import React, { useState } from "react";
import MainLayout from "components/layout/main-layout/MainLayout";
import { titles } from "constants/titles";
import CustomInput from "components/widgets/custom-input/CustomInput";
import CustomButton from "components/widgets/custom-button/CustomButton";
import OTPModal from "components/layout/otp-modal/OTPModal";
import { isEmpty, isValidEmail } from "utility";
import { adminGenrateOtp } from "redux/AdminScreens/action";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import alerts from "constants/alerts";

const CustomerLogin = () => {
  const [loginState, setLoginState] = useState({
    email: "",
    password: "",
    device_token: "",
    isShowPassword: false,
  });
  const [verificationPopUp, setVerificationPopUp] = useState(false);

  // Field error state (like mobile app)
  const [fieldErrors, setFieldErrors] = useState({
    email: false,
  });

  // State to track if validation has been triggered
  const [validationTriggered, setValidationTriggered] = useState(false);

  const loading = useSelector((store) => store?.auth?.loading);
  const dispatch = useDispatch();
  const history = useHistory();

  const onApiResponse = (message, type) => {
    console.log(message, type);
  };

  const onValueChange = (type, e) => {
    let newText = e?.target?.value;
    setLoginState((prev) => {
      return { ...prev, [type]: newText };
    });

    // Real-time validation after submit has been clicked (like mobile app)
    if (validationTriggered) {
      if (type === 'email') {
        if (isEmpty(newText) || !isValidEmail(newText)) {
          setFieldErrors(prev => ({ ...prev, email: true }));
        } else {
          setFieldErrors(prev => ({ ...prev, email: false }));
        }
      }
    }
  };

  const handleOnGetOtp = () => {
    // Set validation triggered to true (like mobile app)
    setValidationTriggered(true);
    
    // Clear previous errors
    setFieldErrors({ email: false });
    
    // Validate fields (like mobile app: check isEmpty AND isValidEmail)
    let hasErrors = false;
    if (isEmpty(loginState?.email) || !isValidEmail(loginState?.email)) {
      setFieldErrors(prev => ({ ...prev, email: true }));
      hasErrors = true;
    }
    
    if (!hasErrors) {
      adminGenrateOtp(
        dispatch,
        { email: loginState?.email },
        history,
        setVerificationPopUp,
        onApiResponse
      );
    }
  };

  const getAdminOtpCall = () => {
    adminGenrateOtp(
      dispatch,
      { email: loginState?.email },
      history,
      setVerificationPopUp,
      onApiResponse
    );
  };

  return (
    <MainLayout
      text={titles?.customer_login}
      isBackHide={false}
      isNavbar={false}
      isLoading={loading}
      white={true}
    >
      <OTPModal
        show={verificationPopUp}
        setShow={setVerificationPopUp}
        onResendOtp={getAdminOtpCall}
      />
      <CustomInput
        label={titles?.email}
        type="email"
        value={loginState?.email}
        error={validationTriggered && fieldErrors?.email}
        errorMessage={validationTriggered && fieldErrors?.email ? alerts?.incorrect_details : ""}
        onChange={(value) => {
          onValueChange("email", value);
        }}
      />
      <CustomButton
        text={titles?.get_otp}
        width={'100%'}
        className={'mt20'}
        onClick={() => handleOnGetOtp()}
      />
    </MainLayout>
  );
};

export default CustomerLogin;
